<template>
  <!-- 保险服务详情 -->
  <div class="s-financialApplyFor-container container financialApplyFor insuranceDetail">
    <topNav></topNav>
    <!-- 面包屑 -->
    <div class="section w1300 marginAuto">
      <div class="crumbs">
        <img src="../assets/image/index/home.png" class="img" alt />
        <span class="go">金融保险&gt;</span>
        <span>金融保险详情</span>
      </div>
      <div class="weatherindex">
        <div class="weather_left">
          <img :src="defaultImg" alt="" class="bankLogo" v-if="dataSource.img ==null || dataSource.img ==''">
          <img v-else :src="dataSource.img.indexOf('http') >=0?dataSource.img:imgURL+'/'+dataSource.img" alt="" class="bankLogo" />
        </div>
        <div class="weather_right">
          <p>{{ dataSource.insuranceName | empty }}</p>
          <div class="lableitemcontent">
            <div class="lableitem">
              适用人群：<span>{{ dataSource.applicablePeople | empty }}</span>
            </div>
            <div class="lableitem">
              投保作物：<span>{{ dataSource.safeguardItems | empty }}</span>
            </div>
            <div class="lableitem">
              保障期限：<span>{{ dataSource.term | empty }}</span>
            </div>
            <div class="lableitem">
              保险公司：<span>{{ dataSource.insuranceCompanyName | empty }}</span>
            </div>
            <div class="lableitem">
              保单形势：<span>{{ dataSource.formInsurance | empty }}</span>
            </div>
            <div class="last_lableitem">
              保障范围：<span>{{ dataSource.scopeApplication | empty }}</span>
            </div>
          </div>
          <div class="price_show">
            ￥ <span class="num">{{ dataSource.amountInsured | empty }}</span> 元/亩起
          </div>
          <div class="toubao">立即投保</div>
        </div>

      </div>
      <!-- tabshow -->
      <div class="tabshow">
        <div class="tabbtncontent">
          <div class="btnlist" @click="handleBtn(index, item)" :class="{ 'btnlist_active': ativeBtn == index }"
            v-for="(item, index) in btnlist" :key="index">{{ item.name }}</div>
        </div>
        <component class="detailitem" :data="data" :is='iscomponent'></component>
      </div>
    </div>
  </div>
</template>

<script>
import topNav from "@/components/topNav.vue";
import { getById } from "@/utils/api/financialInsurance";
export default {
  components: {
    topNav,
    plan: () => import("@/components/insurance/plan.vue"),
    feature: () => import("../components/insurance/productfeature.vue"),
    insure: () => import("../components/insurance/insure.vue"),
    process: () => import("../components/insurance/process.vue"),
    problem: () => import("../components/insurance/problem.vue"),
  },
  data() {
    return {
      //   btnlist: ["产品特色", "保障计划", "投保须知", "理赔流程", "常见问题"],
      dataSource: {},
      iscomponent: "feature",
      data: null,
      defaultImg: require("../assets/image/dealmakers/default.png"),
      btnlist: [
        {
          name: "产品特色",
          code: "feature",
        },
        {
          name: "保障计划",
          code: "plan",
        },
        {
          name: "投保须知",
          code: "insure",
        },
        {
          name: "理赔流程",
          code: "process",
        },
        {
          name: "常见问题",
          code: "problem",
        },
      ],
      ativeBtn: 0,
    };
  },
  computed: {
    detailid() {
      return this.$route.query.id;
    },
  },

  created() {
    this.getById();
    // console.log(this.$route.query);
  },
  methods: {
    handleBtn(idx, val) {
      this.ativeBtn = idx;
      this.iscomponent = val.code;
      //产品特色
      if (this.iscomponent == "feature") {
        console.log("this.dataSource", this.dataSource);
        this.data = this.dataSource.productFeatures?.split("\n");
        // console.log("this.data", this.data);
      }
      //保障计划
      if (this.iscomponent == "plan") {
        this.data = {
          amountInsured: this.dataSource.amountInsured,
          safeguardItems: this.dataSource.safeguardItems,
          scopeApplication: this.dataSource.scopeApplication,
        };
        console.log("this.data", this.data);
      }
      //投保须知
      if (this.iscomponent == "insure") {
        this.data = this.dataSource.insuranceInstruction;
        console.log("this.data", this.data);
      }
      //理赔流程
      if (this.iscomponent == "process") {
        // this.data = this.dataSource.productFeatures?.split("\n");
        console.log("this.data", this.data);
      }
      //常见问题
      if (this.iscomponent == "problem") {
        this.data = this.dataSource.problemList;
        console.log("this.data", this.data);
      }
    },
    async getById() {
      console.log("1d", this.detailid);
      let res = await getById({
        id: this.detailid,
      });
      if ([200, 0].includes(res.data.code)) {
        console.log(123, res.data.data);
        this.dataSource = { ...res.data.data };
        if (this.dataSource.img&&this.dataSource.img[this.dataSource.img.length - 1] == ',') {
          this.dataSource.img = this.dataSource.img.slice(0, this.dataSource.img.length - 1 )
          console.log(this.dataSource.img);
          }
        //产品特色
        if (this.iscomponent == "feature") {
          console.log("this.dataSource", this.dataSource);
          this.data = this.dataSource.productFeatures?.split("\n");
          console.log("this.data", this.data);
        }
      }
    },
  },
  mounted() { },
  watch: {
    iscomponent: {
      //   immediate: true,
      handler(nval, oval) {
        if (nval != oval) {
        }
      },
    },
  },
  filters: {
    empty(val) {
      if (!val) return "--";
      else {
        return val;
      }
    },
  },
};
</script>

<style lang="scss">
@import "../utils/css/common.scss";
@import "../utils/css/insuranceDetail.scss";
</style>